<template>
  <a
    v-if="href"
    class="dropdown-item"
    :href="href"
  >
    <i
      v-if="icon"
      class="btn-icon"
      :class="[!!text ? 'mr-2' : '', 'fa', `fa-${icon}`]"
    ></i>
    {{ $t(text) }}
  </a>
  <button
    v-else
    class="dropdown-item"
    :class="btnClass"
    type="button"
    @click="click()"
  >
    <i
      v-if="icon"
      class="btn-icon"
      :class="[!!text ? 'mr-2' : '', 'fa', `fa-${icon}`]"
    ></i>
    {{ $t(text) }}
  </button>
</template>

<script>
export default {
  name: 'DropdownMenuButton',
  props: {
    icon: {
      type: String,
    },
    routeTo: {
      type: Object,
    },
    href: {
      type: String,
      required: false,
    },
    text: {
      type: String,
    },
    textColor: {
      type: String,
      required: false,
    },
    selected: {
      type: Boolean,
    },
  },
  computed: {
    btnClass() {
      const classList = [];
      if (this.selected) {
        classList.push('bg-light');
      }
      if (this.textColor) {
        classList.push(`text-${this.textColor}`);
      }
      return classList;
    },
  },
  methods: {
    click() {
      if (this.routeTo) {
        this.$router.push(this.routeTo);
      } else {
        this.$emit('click');
      }
    },
  },
};
</script>
